import FChartLineMDP from './FChartLineMDP';
import FPointLabelsMDP from './FPointLabelsMDP';
import FC3ChartMDP, { ChartType } from './FC3ChartMDP';
import FXAxisMDP from './FXAxisMDP';
import FYAxisMDP from './FYAxisMDP';

export default class FBarFC3ChartMDP extends FC3ChartMDP {
  constructor({
    chartTitle,
    xAxis,
    yAxis,
    pointLabels,
    legendShow,
  }: {
    chartTitle?: string;
    xAxis: FXAxisMDP;
    yAxis?: FYAxisMDP;
    pointLabels?: FPointLabelsMDP;
    legendShow?: boolean;
  }) {
    super({
      myRefName: 'barC3ChartRef',
      type: ChartType.BAR,
      chartTitle: chartTitle,
      xAxis: xAxis,
      yAxis: yAxis,
      pointLabels: pointLabels,
      legendShow: legendShow,
    });
  }

  addBar(newField: { dataSelectorKey: string; legend: string; type?: string }) {
    if (!newField.type) {
      newField.type = this.type;
    }
    this.dataSelectorKeyList.push(new FChartLineMDP(newField));
    return this;
  }
}
